import { render, staticRenderFns } from "./SatiraSection.vue?vue&type=template&id=489f78ad&scoped=true&"
import script from "./SatiraSection.vue?vue&type=script&lang=js&"
export * from "./SatiraSection.vue?vue&type=script&lang=js&"
import style0 from "./SatiraSection.vue?vue&type=style&index=0&id=489f78ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489f78ad",
  null
  
)

export default component.exports